import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./authContext";

const ProtectedRoute = ({ element, adminOnly = false }) => {
  const { user } = useAuth();

  if (user === null) {
    return <div>Loading...</div>; // Falls der Auth-Status noch nicht geladen ist
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !user.isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return element;
};

export default ProtectedRoute;